/**
 * Audit Events Module Routes (Expansão v2 / Épico E4 / Story E4.2.2).
 *
 * Permissão ``audit:read`` JÁ está seedada no DB
 * (``app/db/seeds/audit_permissions_seed.py`` — atribuída a
 * admin/gerente/operador). Backend gateia com
 * ``require_permissions(["audit:read"])`` em ``audit_events.py``
 * (Story E4.2.1) e ``RequirePermission`` no frontend evita request
 * inútil pra users sem a permissão.
 *
 * **Por que rota separada (não dentro de ``admin.routes.tsx``):** Audit
 * é módulo registrado em ``system_modules`` com seu próprio
 * ``frontend_route`` (decisão E4.2.2 — pattern "criar módulo novo" do
 * CLAUDE.md). Ter um ``ModuleRoutes`` próprio facilita gate + permite
 * o lazy chunk separado (~20KB gz, AC da story).
 */

import { lazy } from "react";

import { ModuleRoutes } from "../types";

const AuditEventsPage = lazy(() => import("@/pages/admin/AuditEventsPage"));

export const auditEventsRoutes: ModuleRoutes = {
  moduleId: "audit_events",
  basePath: "/admin/audit-events",
  routes: [
    {
      path: "/admin/audit-events",
      element: <AuditEventsPage />,
      permission: { resource: "audit", action: "read" },
    },
  ],
};
